// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root___72W_","tab":"Tabs_tab__1Poo3","tabActive":"Tabs_tabActive__1QXcp"};